<template>
  <div class="text-template-list">
    <v-container
      fluid
      grid-list-xl
    >
      <v-layout
        row
        wrap
      >
        <v-flex lg12>
          <Toolbar
            :handle-add="addHandler"
            :enable-refresh="true"
            :handle-refresh="refreshData"
            :title="$t('Subscriptions')"
          />
          <DataFilter
            :handle-filter="onSendFilter"
            :handle-reset="resetFilter"
          >
            <SubscriptionFilterForm
              :values="filters"
              ref="filterForm"
              slot="filter"
            />
          </DataFilter>
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :loading="isLoading"
            :loading-text="$t('Loading...')"
            :options.sync="options"
            :server-items-length="totalItems"
            @update:options="onUpdateOptions"
            class="elevation-1"
            item-key="@id"
            v-model="selected"
          >
            <template
              slot="item.enabled"
              slot-scope="{ item }"
            >
              <v-icon v-if="item.enabled">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-close-circle</v-icon>
            </template>
            <ActionCell
              :handle-delete="() => deleteHandler(props.item)"
              :handle-edit="() => editHandler(props.item)"
              slot="item.action"
              slot-scope="props"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";
  import ListMixin from "../../mixins/ListMixin";
  import ActionCell from "../../components/ActionCell";
  import Toolbar from "../../components/Toolbar";
  import DataFilter from "../../components/DataFilter";
  import SubscriptionFilterForm from "../../components/subscription/Filter";

  export default {
    name: "SubscriptionList",
    servicePrefix: "Subscription",
    mixins: [ListMixin],
    components: {
      Toolbar,
      ActionCell,
      DataFilter,
      SubscriptionFilterForm,
    },
    data() {
      return {
        headers: [
          { text: this.$i18n.t("name"), value: "name" },
          { text: this.$i18n.t("price"), value: "price" },
          {
            text: this.$i18n.t("Actions"),
            value: "action",
            sortable: false,
            align: "center",
          },
        ],
        selected: [],
        filters: {
          __Fexists: { parent: false }
        },
        showSubscriptionDialog: false,
        subscriptionItem: {},
        showSubscriptionDialogForm: false,
        subscriptionFormItem: {},
        subscriptionDialogTitle: this.$t("AddSubscription"),
      };
    },
    computed: {
      ...mapGetters("subscription", {
        items: "list",
      }),
      ...mapFields("subscription", {
        deletedItem: "deleted",
        error: "error",
        isLoading: "isLoading",
        resetList: "resetList",
        totalItems: "totalItems",
        view: "view",
      }),
    },
    methods: {
      ...mapActions("subscription", {
        getPage: "fetchAll",
        deleteItem: "del",
        clearSubscriptionData: 'resetAllData',
      }),
      resetFilter() {
        this.filters = {
          profile: {},
        };
      },
      subscriptionDialogControl(close = false) {
        this.showSubscriptionDialogForm = !close;
      },
      handleCreated(item) {
        console.log(item);
      },
      handleUpdated(item) {
        console.log(item);
      },
      createOrEditSubscriptionHandler(item) {
        this.subscriptionFormItem = item ?? {};
        if (item) {
          this.subscriptionDialogTitle = this.$t("EditSubscription");
        } else {
          this.subscriptionDialogTitle = this.$t("AddSubscription");
        }
        this.subscriptionDialogControl();
      },
      refreshData() {
        this.clearSubscriptionData();
        this.onSendFilter();
      }
    },
  };
</script>
